module.exports = __webpack_public_path__ + "static/media/sensor-bike.11e490ae.jpg";